import type { Menu } from '~/types/api'

export function useMenusState() {
    return useState<Array<Menu> | null>('menus')
}
